import OrchestratorApi from 'Services/Administration/OrchestratorApi';
import {
  changeFeatureIsActive,
  FeatureConstants,
  FeatureToggleActionType,
  getOrCreateFeatureFlag,
} from 'Core/ducks/featureFlag';
import {AsyncResult} from 'Core/models/Async';
import {isRight} from 'fp-ts/lib/Either';
import {all, call, put, takeEvery, takeLatest} from 'redux-saga/effects';

function* getOrCreateFeatureFromApi(action: ReturnType<typeof getOrCreateFeatureFlag>) {
  const {featureName, defaultActive} = action.payload;

  try {
    const result: AsyncResult<boolean> = yield call(
      OrchestratorApi.getFeatureFlagByAccountNumber,
      featureName,
      defaultActive
    );
    if (isRight(result)) {
      yield put(changeFeatureIsActive(featureName, result.right));
    } else {
      yield put(changeFeatureIsActive(featureName, false));
    }
  } catch {
    yield put(changeFeatureIsActive(featureName, false));
  }
}

function* getLandingFooterFeatureFlagFromApi() {
  try {
    const result: AsyncResult<boolean> = yield call(OrchestratorApi.getLandingPageFooterFeatureFlag);
    if (isRight(result)) {
      yield put(changeFeatureIsActive(FeatureConstants.BR_FOOTER, result.right));
    }
  } catch {
    yield put(changeFeatureIsActive(FeatureConstants.BR_FOOTER, false));
  }
}

export function* fetchIsFeatureActive() {
  yield takeEvery(FeatureToggleActionType.GET_OR_CREATE_FEATURE, getOrCreateFeatureFromApi);
}

export function* fetchLandingPageFooterFeatureFlag() {
  yield takeLatest(FeatureToggleActionType.GET_LANDING_PAGE_FOOTER_FEATURE, getLandingFooterFeatureFlagFromApi);
}

export default function*() {
  yield all([fetchLandingPageFooterFeatureFlag(), fetchIsFeatureActive()]);
}
